import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { IEventsDictionary } from '@model/eventsDictionary';

import { apiClient } from '@services/apiClient';

export const userEmailEventDictionaryKey = () => ['userEmailEventDictionary'];
export const userEmailEventDictionaryFn = () => apiClient.get(`${APP_SSO_URL}api/email-event/dictionary`);

const userEmailEventDictionarySelect = ({ data }: AxiosResponse<IEventsDictionary>) => {
  const emailEvents = data.emailEventsDictionary
    ?.filter((ev) => ev.event?.with_settings || ev.with_settings)
    .map((ev) => {
      return { ...ev, event_id: ev.id };
    });

  const additionalEmailEventsList = data?.simpleEventsDictionary.filter((event) => {
    const name = event.name.toLowerCase();

    return name.includes('reminder') || name.includes('deactivate');
  });

  return {
    emailEvents,
    simpleEventsDictionary: data.simpleEventsDictionary || [],
    additionalEmailEventsList,
  };
};

export const useUserEmailEventDictionaryQuery = () => {
  return useQuery({
    queryKey: userEmailEventDictionaryKey(),
    queryFn: userEmailEventDictionaryFn,
    select: userEmailEventDictionarySelect,
  });
};
